import { useNavigate } from 'react-router-dom'
import { Breadcrumb, Flex, Typography } from 'antd'
import { path } from 'src/libs'
import { FormRequest } from './component'
import { RequestPayload } from 'src/pages/budget/budgetRequests/types'
import { useContextRequest } from 'src/pages/budget/budgetRequests/hooks'
import { STATUS_PERIOD } from 'src/pages/budget/const'

type RequestWidgetProps = {
  initialValues: Partial<RequestPayload>
  mode: 'editOwn' | 'editForApprove' | 'createOwn'
  isCeo?: boolean
}

export const RequestWidget = ({
  initialValues,
  mode,
  isCeo,
}: RequestWidgetProps) => {
  const navigate = useNavigate()
  const { Title, Text } = Typography
  const isNew = mode === 'createOwn'
  const isEditForApprove = mode === 'editForApprove'
  const { budgetPeriodList } = useContextRequest()
  const selectedPeriodStatus = budgetPeriodList.find(
    (period) => period.id === initialValues.budgetPeriod,
  )?.status
  const isOutOfBudgetRequest =
    isNew &&
    selectedPeriodStatus !== undefined &&
    selectedPeriodStatus !== STATUS_PERIOD.OPEN_CREATE

  return (
    <Flex vertical gap="middle">
      <Breadcrumb
        items={[
          {
            title: (
              <Text
                style={{
                  cursor: 'pointer',
                  color: 'var(--color-primary)',
                  fontSize: 16,
                }}
                onClick={() => {
                  navigate(path.budget.budgets.entry())
                }}
              >
                Заявки на бюджет
              </Text>
            ),
          },
          {
            title: (
              <Text type="secondary" style={{ fontSize: 16 }}>
                {isNew ? 'Создание заявки' : 'Редактирование заявки'}
              </Text>
            ),
          },
        ]}
      />
      <Title level={1} style={{ marginBottom: 0 }}>
        {isNew
          ? isOutOfBudgetRequest
            ? 'Новая заявка вне бюджета'
            : 'Новая заявка на бюджет'
          : `Редактировать ${isEditForApprove ? 'чужую' : ''} заявку `}
      </Title>
      <FormRequest initialValues={initialValues} mode={mode} isCeo={isCeo} />
    </Flex>
  )
}
